export const LINKS: { label: string; page: number; url?: string }[] = [
  { label: "Home", page: 0 },
  { label: "Key Projects", page: 1 },
  { label: "About", page: 2 },
  { label: "Integrations", page: 4 },
  { label: "Dev Resources", page: -1, url: "https://build.bonkcoin.com" },
  { label: "Contact", page: 7 },
];
